export const LABELS_CONTABEIS = Object.freeze({
  T: "Receita líquida do mês × (1 − %materiais)",
  I: "Estoque em Processo (Obras em Andamento) — Ativo Circulante 1.1.4",
  OE: "Custos Indiretos Fab. + Despesas Adm. + Despesas Comerciais Fixas (DRE)",
  lucro: "Resultado antes de impostos",
  ROI: "Giro do estoque em processo",
});

export function consolidarTOC({
  throughput,
  wipPorEtapa,
  oeMensal = 0,
} = {}) {
  const T = throughput?.ganho ?? 0;
  const buckets = Array.isArray(wipPorEtapa) ? wipPorEtapa : [];
  const I = buckets.reduce((sum, bucket) => sum + (bucket?.valorRS || 0), 0);
  const OE = oeMensal || 0;
  const lucro = T - OE;
  const ROI = I > 0 ? lucro / I : null;

  return {
    T,
    I,
    OE,
    lucro,
    ROI,
    IPorEtapa: buckets.map((bucket) => ({
      etapa: bucket.etapa,
      label: bucket.label,
      valor: bucket.valorRS || 0,
    })),
    labels: LABELS_CONTABEIS,
  };
}

export function montarOE({
  folha = 0,
  encargos = 0,
  aluguel = 0,
  energia = 0,
  depreciacao = 0,
  administrativas = 0,
  comerciais = 0,
  outras = 0,
} = {}) {
  const partes = {
    folha,
    encargos,
    aluguel,
    energia,
    depreciacao,
    administrativas,
    comerciais,
    outras,
  };
  const total = Object.values(partes).reduce(
    (sum, value) => sum + (Number(value) || 0),
    0
  );
  return { partes, total };
}
